import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { message } from 'antd';
import { useAuthStore } from '@/store/authStore';
import type { ApiError } from '@/types';

const baseURL = import.meta.env.VITE_API_BASE_URL ?? '/api';

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// ============================================================
// Request interceptor: inject JWT token
// ============================================================
apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = useAuthStore.getState().token;
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ============================================================
// Response interceptor: chuẩn hóa error, xử lý 401
// ============================================================
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiError>) => {
    if (error.response) {
      const { status, data } = error.response;

      switch (status) {
        case 401:
          useAuthStore.getState().logout();
          message.error('Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại');
          window.location.href = '/login';
          break;
        case 403:
          message.error('Bạn không có quyền thực hiện thao tác này');
          break;
        case 404:
          // Không toast — component tự xử lý
          break;
        case 422:
          message.error(data?.message ?? 'Dữ liệu không hợp lệ');
          break;
        case 500:
        case 502:
        case 503:
          message.error('Lỗi hệ thống, vui lòng thử lại sau');
          break;
        default:
          message.error(data?.message ?? 'Đã có lỗi xảy ra');
      }
    } else if (error.request) {
      message.error('Không kết nối được tới máy chủ');
    }
    return Promise.reject(error);
  },
);
